import { render, staticRenderFns } from "./SurveyUnmatchedView.vue?vue&type=template&id=07201d64&"
import script from "./SurveyUnmatchedView.vue?vue&type=script&lang=js&"
export * from "./SurveyUnmatchedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports